const defaults = {
    log: {},
}

export default (state = defaults, action) => {
    switch (action.type) {
        case 'STATS_LOG':
            return {...state, log: action.payload || {}};
        case 'MTA_CLICK':
            window.MtaH5 && window.MtaH5.clickStat(action.payload);
            window._czc && window._czc.push(["_trackEvent", 'common', 'click', action.payload, 1])
            return {...state};
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/stats.js